import styles from './Encyclopedia.module.scss'
import { EncyclopediaProps } from './types'
import EncyclopediaSearchBar from 'features/encyclopedia/components/search-bar/EncyclopediaSearchBar'
import { Header } from '@boltenergy-be/design-system'
import EncyclopediaArticles from './components/encyclopedia-articles/EncyclopediaArticles'

const Encyclopedia = ({ articles, categories, content, defaultCategory }: EncyclopediaProps) => {
  // Constants
  const { description, searchTitle, title } = content

  return (
    <main>
      {/* INTRO */}
      <Header docked color="light" title={title} classnames={{ container: styles.header, content: styles['header-content'] }}>
        <p>{description}</p>
        <EncyclopediaSearchBar label={searchTitle} className={styles.search} />
      </Header>

      <EncyclopediaArticles {...{ articles, categories, defaultCategory }} />
    </main>
  )
}

export default Encyclopedia
